import _ from 'lodash';
import { mapState } from 'vuex';
import { campaign, SearchTable, permissions } from '~';

const endpoint = campaign.endpoint;
const enabledFields = campaign.enabledFields;
const enabledFieldsMD = campaign.enabledFieldsMD;
const enabledFieldsSM = campaign.enabledFieldsSM;
const availableFilters = campaign.availableFilters;

export default {
  components: {
    'search-table': SearchTable,
  },
  computed: {
    ...mapState('auth', { currentUser: 'user' }),
    ...mapState('publicConfig', ['config']),
    disabledFields() {
      return _.get(this.config, 'disabled_columns.lab.campaigns', []);
    },
    options() {
      const enabledFilersFields = [
        [
          'startDate', 'statuses', 'issues', 'modes', 'goalType',
          'format', 'adStatus', 'numberOfReworks', 'campaignCreator', 'clientLanguage',
        ],
      ];

      if (permissions.canGlobal(this.currentUser, 'Campaign', ['viewAllStatuses'])) {
        enabledFilersFields[0].push('createdAt', 'daysInCurrentStatus', 'statusFlows');
      }
      const availableFields = campaign.availableFields(this.disabledFields);
      if (permissions.canGlobal(this.currentUser, 'Campaign', ['seeAutopublish'])) {
        enabledFilersFields[0].push('autopublish');
      } else if (availableFields.autopublish) {
        delete availableFields.autopublish;
      }

      if (permissions.canGlobal(this.currentUser, 'Campaign', ['seeIsUpsell'])) {
        enabledFilersFields[0].push('isUpsell');
      } else if (availableFields.is_upsell) {
        delete availableFields.is_upsell;
      }

      if (!permissions.canGlobal(this.currentUser, 'Campaign', ['seeConfirmedAtDate'])
        && availableFields.confirmed_at) {
        delete availableFields.confirmed_at;
      }
      if (!permissions.canGlobal(this.currentUser, 'Campaign', ['seeStatusStartDate'])
        && availableFields.status_start_date) {
        delete availableFields.status_start_date;
      }

      if (!permissions.canGlobal(this.currentUser, 'User', ['loginLab'])) {
        delete availableFields.reach_overall;
        delete availableFields.clicks_overall;
        delete availableFields.leads_overall;
        delete availableFields.offers_overall;
        delete availableFields.createdAt;
      }

      if (!permissions.canGlobal(this.currentUser, 'Campaign', ['viewAll'])) {
        delete availableFields.days_in_current_status;
        delete availableFields.working_days_in_current_status;
      }

      if (!permissions.canGlobal(this.currentUser, 'Campaign', ['hasChangeTargetPermission'])) {
        delete availableFields.target_change_status;
      }
      return {
        endpoint,
        fields: availableFields,
        enabledFields,
        enabledFieldsMD,
        enabledFieldsSM,
        availableFilters,
        enabledFilters: enabledFilersFields,
      };
    },
  },
  methods: {
    openItemUrl(item) {
      return { name: 'campaign', params: { code: item.code } };
    },
  },
  mounted() {
    const user = this.currentUser;
    if (user.only_campaign) {
      this.$router.replace({ path: `/campaign/${user.only_campaign}` });
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/campaigns/Campaigns.js